


















































import { Component, Vue, Prop } from "vue-property-decorator";
import { Module } from "../types";

interface ListItem {
  title: string;
  subtitle: string;
  icon: string;
  bundle: string;
  bundleDescription: string;
  active: boolean;
  activeClasses: string[];
  license: boolean;
  licenseClasses: string[];
  show: boolean;
  index: number;
}

@Component
export default class ModuleList extends Vue {
  @Prop({ required: true })
  modules!: Module[];

  @Prop({ required: true })
  bundle!: string;

  @Prop({ required: true })
  activeModules!: string[];

  get items(): ListItem[] {
    return this.modules
      .filter(mod => !mod.hide || this.activeModules.includes(mod.name))
      .map(mod => {
        const active = this.activeModules.includes(mod.name);
        const activeClasses = this.getActiveClass(active);
        const license = this.inBundle(mod.bundle, mod.name);
        const licenseClasses = this.getInlicenseClass(license);
        const index = +new Date();

        return {
          title: mod.title,
          subtitle: mod.subtitle,
          icon: mod.icon,
          bundle: mod.bundle,
          bundleDescription: this.getBundleDescription(mod.bundle),
          active,
          activeClasses,
          license,
          licenseClasses,
          show: true,
          index
        };
      });
  }

  get groupedItems(): { label: string; items: ListItem[] }[] {
    const active = this.items.filter(mod => mod.active);
    const inactive = this.items.filter(mod => !mod.active && mod.license);
    const noLicense = this.items.filter(mod => !mod.active && !mod.license);

    const res = [];
    if (active.length > 0)
      res.push({
        label: this.t("activeModules"),
        items: active
      });

    if (inactive.length > 0)
      res.push({
        label: this.t("inactiveLicensedModules"),
        items: inactive
      });

    if (noLicense.length > 0)
      res.push({
        label: this.t("inactiveUnlicensedModules"),
        items: noLicense
      });

    return res;
  }

  inBundle(bundle: string, name: string): boolean {
    return (
      bundle === this.bundle ||
      (bundle === "a-la-carte" &&
        this.activeModules.includes(name.replace("active", "licensed"))) ||
      (bundle === "lite" && this.bundle === "complete")
    );
  }

  getActiveClass(active: boolean): string[] {
    if (active) return ["secondary--text"];
    return ["accent--text", "text--darken-1"];
  }

  getInlicenseClass(inLicense: boolean): string[] {
    if (inLicense) return ["success--text"];
    return ["error--text"];
  }

  getBundleDescription(bundle: string): string {
    switch (bundle) {
      case "lite":
        return this.t("partOfBundle.lite");
      case "complete":
        return this.t("partOfBundle.complete");
      case "a-la-carte":
        return this.t("partOfBundle.aLaCarte");
      default:
        return this.t("partOfBundle.unknown");
    }
  }

  private t(key: string): string {
    return this.$t("compendalicense.terms." + key).toString();
  }
}
